import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "w-100" }

import { ref, watch, withDefaults } from 'vue';
import { Group } from '@/core/model';
import { AtomButton } from '@/components/atoms';
import { MoleculeModal } from '@/components/molecules';
import { IHeadersTable } from '@/types';

import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
const filters = true;
interface IProps {
    showModal: boolean;
    group?: Group;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeGoalDetailingModal',
  props: {
    showModal: { type: Boolean, default: false },
    group: {}
  },
  setup(__props: any) {

let locale:string = messages[getLanguage()]['message'];  

const perPage = ref<number>(10);
const totalRows = ref(0);
const page = ref<number>(1);
const headers = ref<IHeadersTable[]>([
    { label: locale['goals_create']['employee'], field: 'Collaborator' },
    { label: locale['common']['role'], field: 'Function' },
    { label: locale['common']['performer'], field: 'Performer' },
    { label: locale['results']['goal'], field: 'Goal' },
    { label: 'Início', field: 'Start' },
    { label: 'Fim', field: 'End' },
    { label: locale['common']['brand'], field: 'Brand' },
    { label: 'Meta anual', field: 'AnnualTarget' },
    { label: '0 - 70', field: '70' },
    { label: '70,01 - 83', field: '83' },
    { label: '83,01 - 100', field: '100' },
    { label: 'Perf. ' + locale['common']['required'], field: 'Mandatory' },
    { label: locale['common']['cross'], field: 'Cross' },
]);

const items = ref<Group[]>([]);
const props = __props

const show = ref<boolean>(props.showModal);
watch(() => props.showModal,
    () => {
        show.value = props.showModal;
    })


return (_ctx: any,_cache: any) => {
  const _component_MoleculeTable = _resolveComponent("MoleculeTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_ctx.showModal) + " ", 1),
    _createVNode(_unref(MoleculeModal), {
      width: "1192px",
      onHasBtnClose: ($event: any) => (false),
      onHasBtnConfirm: ($event: any) => (false),
      onHandleCancel: _cache[0] || (_cache[0] = ($event: any) => (show.value = false)),
      title: "Realizar cadastro de Metas",
      subtitle: 'Preencha todos os campos corretamente para cadastrar uma nova meta',
      show: show.value
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_MoleculeTable, {
              headers: headers.value,
              items: items.value,
              filters: "",
              totalItems: totalRows.value,
              perPage: perPage.value,
              page: page.value
            }, {
              actions: _withCtx(() => [
                _createVNode(_unref(AtomButton), null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Gerar ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["headers", "items", "totalItems", "perPage", "page"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})